let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("4gpLy")]).then(() => parcelRequire('6UP22'));